import { memoPx2Rem } from './cssHelpers'
// !### DEPRECATED
// This file to be deleted in the future. See: utils/cssHelpers.js

// const pixels2rem = pixels => `${pixels / MFP.vars.emSize.replace(/px/g, '')}rem`

export default memoPx2Rem
